export default __webpack_public_path__ + "static/media/Profile.33ad118f.svg";